import {URL} from "utils/constants";

const ParticlePresets = (preset, value) => {
  const S3_URL = URL.S3_ASSET_ETC;

  switch (preset) {
    case "default":
      return {
        presetName: "default",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 5,
              particlesMax: 7,
              perSecondMin: 0.1,
              perSecondMax: 0.2,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 1,
                  max: 1.5,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: value || S3_URL + "/asset/particleTexture/fx_EnergyBolt2.png",
                  //temporal condition for old library. need to delete later
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 50,
                  x: 0,
                  y: 1,
                  z: 0,
                  theta: 30,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#FFFFFF",
                  colorB: "#FFFFFF",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.4,
                  scaleB: 0.2,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: 0,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: -1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "starFountain":
      return {
        presetName: "starFountain",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 50,
              particlesMax: 50,
              perSecondMin: 0.8,
              perSecondMax: 0.8,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 1.2,
                  max: 1.8,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Flare6.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 80,
                  x: 0,
                  y: 1,
                  z: 0,
                  theta: 45,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#E44D16",
                  colorB: "#C5E416",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.4,
                  scaleB: 0.2,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: -3,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: -1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "explosion":
      return {
        presetName: "explosion",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 50,
              particlesMax: 50,
              perSecondMin: 1,
              perSecondMax: 1,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 3,
                  max: 3,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 0.4,
                  max: 0.5,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Fire1.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 70,
                  x: 0,
                  y: 1,
                  z: 0,
                  theta: 80,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#E44D16",
                  colorB: "#4C0D0A",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 1,
                  scaleB: 0.1,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: -3,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: 0.1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 0,
                  y: 1,
                  z: 0,
                },
              },
            ],
          },
        ],
      };
    case "attraction":
      return {
        presetName: "attraction",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 70,
              particlesMax: 70,
              perSecondMin: 1,
              perSecondMax: 1,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Flare12.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 40,
                  x: 0,
                  y: 1,
                  z: 0,
                  theta: 180,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#3A16E4",
                  colorB: "#6B128E",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.7,
                  scaleB: 0.3,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: 1,
                },
              },
            ],
          },
        ],
      };
    case "smoke":
      return {
        presetName: "smoke",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 10,
              particlesMax: 10,
              perSecondMin: 0.2,
              perSecondMax: 0.2,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 2,
                  max: 2,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 1.4,
                  max: 2.0,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Fog1.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 0,
                  x: 0,
                  y: 0,
                  z: 0,
                  theta: 90,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 0,
                  alphaB: 0.2,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#FFFFFF",
                  colorB: "#FFFFFF",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 1.0,
                  scaleB: 0.9,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: 0,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: -1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 1,
                  y: 0,
                  z: 1,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "rain":
      return {
        presetName: "rain",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 50,
              particlesMax: 50,
              perSecondMin: 0.08,
              perSecondMax: 0.08,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 1.0,
                  max: 1.0,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/tex_Rain3.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 50,
                  x: 0,
                  y: -1,
                  z: 0,
                  theta: 90,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 0.2,
                  alphaB: 0.6,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#FFFFFF",
                  colorB: "#FFFFFF",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.6,
                  scaleB: 0.4,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: -0.5,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: -2,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 7,
                  y: 0,
                  z: 7,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "snow":
      return {
        presetName: "snow",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 50,
              particlesMax: 50,
              perSecondMin: 0.2,
              perSecondMax: 0.2,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 1.2,
                  max: 1.8,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Glow2.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 0,
                  x: 0,
                  y: 0,
                  z: 0,
                  theta: 90,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 0,
                  alphaB: 0.4,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#FFFFFF",
                  colorB: "#FFFFFF",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.4,
                  scaleB: 0.2,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: -0.3,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: -1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 7,
                  y: 0,
                  z: 7,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "fire":
      return {
        presetName: "fire",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 5,
              particlesMax: 7,
              perSecondMin: 0.05,
              perSecondMax: 0.05,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 0.8,
                  max: 1.1,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Fire1.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 2,
                  x: 0,
                  y: 1,
                  z: 0,
                  theta: 60,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#A01717",
                  colorB: "#CFD02E",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.4,
                  scaleB: 0,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: 1.2,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: 1.1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 1.5,
                  y: 0,
                  z: 1.5,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "fireworks":
      return {
        presetName: "fireworks",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 120,
              particlesMax: 120,
              perSecondMin: 1.5,
              perSecondMax: 1.0,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 0.8,
                  max: 1.1,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_EnergyBolt5.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 80,
                  x: 0,
                  y: 1,
                  z: 0,
                  theta: 180,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#A01717",
                  colorB: "#CFD02E",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.6,
                  scaleB: 0,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: -1.5,
                  fz: 0,
                },
              },
              {
                type: "Attraction",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  force: -1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                },
              },
              {
                type: "Spring",
                properties: {
                  x: 0,
                  y: 0,
                  z: 0,
                  spring: 0,
                  friction: 0,
                },
              },
            ],
          },
        ],
      };
    case "starTunnel":
      return {
        presetName: "starTunnel",
        preParticles: 0,
        integrationType: "euler",
        emitters: [
          {
            rate: {
              particlesMin: 5,
              particlesMax: 5,
              perSecondMin: 0.04,
              perSecondMax: 0.04,
            },
            initializers: [
              {
                type: "Mass",
                properties: {
                  min: 1,
                  max: 1,
                },
              },
              {
                type: "Life",
                properties: {
                  min: 5,
                  max: 5,
                },
              },
              {
                type: "BodySprite",
                properties: {
                  texture: S3_URL + "/asset/particleTexture/fx_Flare6.png",
                },
              },
              {
                type: "RadialVelocity",
                properties: {
                  radius: 20,
                  x: 0,
                  y: 0,
                  z: -1,
                  theta: 60,
                },
              },
            ],
            behaviours: [
              {
                type: "Alpha",
                properties: {
                  alphaA: 1,
                  alphaB: 0,
                },
              },
              {
                type: "Color",
                properties: {
                  colorA: "#A01717",
                  colorB: "#CFD02E",
                },
              },
              {
                type: "Scale",
                properties: {
                  scaleA: 0.3,
                  scaleB: 0.2,
                },
              },
              {
                type: "Force",
                properties: {
                  fx: 0,
                  fy: 0,
                  fz: -1,
                },
              },
              {
                type: "RandomDrift",
                properties: {
                  x: 0,
                  y: 0,
                  z: 3,
                },
              },
            ],
          },
        ],
      };
    default:
      break;
  }
};

export default ParticlePresets;
